import axiosServices from './request';

const AppCenter = axiosServices('appcenter');

export default {
  getListAllRaysAppWithDelete: AppCenter('get', 'appRays/listAllRaysAppWithDelete'),
  /** 获取微课信息 */
  getResourceList: AppCenter('get', 'appResourceVideo/getResourceListByCookie'),
  /** 微课已读 */
  readById: AppCenter('get', 'appResourceVideo/readById'),
  /** 获取微课价格配置 */
  getBySettingId2C: AppCenter('get', 'microPriceSetting/getBySettingId2C')
};

